/**
 * Must match `IDENTITY_CENTER_PROVIDER_NAME` in `infra/lib/authentication-stack.ts`, which is the name
 * the SAML provider is registered under in the admin Cognito pool. Nothing type-checks across that
 * boundary — the two live in different build graphs — so this comment is the only link between them.
 * Changing one without the other makes sign-in fail with an opaque Cognito error.
 */
export const IDENTITY_CENTER_PROVIDER_NAME = "IdentityCenter";
